export default {
    routerName: '公告管理',
    announce: {
        searchName: '検索条件',
        name: '公告名',
        thumb: '缩略图',
        image: '图片',
        description: '描述',
        startTime: '开始时间',
        endTime: '结束时间',
        level: '重要度',
        level0: '普通',
        level1: '正常',
        level2: '重要',
        scope: '范围',
        scope0: '前台',
        scope1: '后台',
        scope2: '前后台',
        status: '状态',
        open: '启用',
        close: '停用',
        createTime: '创建时间',
        createStartTime: '创建开始时间',
        createEndTime: '创建结束时间',
        releaseDateStartTime: '开始起始时间',
        releaseDateEndTime: '开始终止时间',
    },
    table: {
        id: 'ID',
        thumb: '缩略图',
        image: '图片',
        name: '公告名',
        startTime: '开始时间',
        endTime: '结束时间',
        level: '重要度',
        scope: '范围',
        status: '状态',
        createBy: '创建者',
        createTime: '创建时间',
    },
};
